import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { createGlobalStyle } from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';

import Header from './header';
import media from '../utils/media';
import StyledLink from '../utils/styled-link';

import Rss from '../images/social/rss.svg';

const GlobalStyles = createGlobalStyle`
  @import url('https://rsms.me/inter/inter-ui.css');

  @font-face {
    font-family: system;
    font-style: normal;
    font-weight: 300;
    src: local('.SFNSText-Light'), local('.HelveticaNeueDeskInterface-Light'),
      local('.LucidaGrandeUI'), local('Ubuntu Light'), local('Segoe UI Light'),
      local('Roboto-Light'), local('DroidSans'), local('Tahoma');
  }

  :root {
    font-size: 10px;
  }

  body {
    font-family: 'Inter UI', sans-serif;
    margin: 0;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    color: rgba(0, 0, 0, 0.8);
    min-height: 100vh;
    position: relative;
    font-size: 1.6rem;
    font-weight: 300;
  }

  a {
    color: crimson;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Inter UI', sans-serif;
  }

  h2 {
    font-size: 2.5rem;
  }

  h3 {
    font-size: 2.4rem;
  }

  h4 {
    font-size: 1.6rem;
  }
  
  code {
    font-family: Menlo,Monaco,"Courier New",Courier,monospace;
    word-break: break-word;
  }

  pre code {
    word-break: normal;
  }

  :not(pre) > code[class*="language-"], pre[class*="language-text"] {
    background-color: transparent;
    color: inherit;
    font-size: medium;
  }
`;

const Footer = styled.footer`
  display: flex;
  justify-content: space-between;
  width: 60%;
  max-width: 728px;
  margin: 0 auto;

  ${media.tablet`
    width: 80%;
  `}
`;

const IconLinks = styled.div`
  display: flex;
  height: 6rem;
`;

const Content = styled.div`
  width: 60%;
  max-width: 728px;
  margin: 0 auto;

  ${media.tablet`
    width: 80%;
  `}
`;

const SocialIcon = styled.img`
  height: 1.5rem;
  width: 1.5rem;
  padding: 1.5rem 1rem;
  color: black;
`;

class Layout extends Component {
  render() {
    const { children } = this.props;
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Header title={data.site.siteMetadata.title} />
            <Content>{children}</Content>
            <Footer>
              <IconLinks>
                <StyledLink to="/">
                  <span role="img" aria-label="Home">
                    👨‍💻🏠
                  </span>
                </StyledLink>
              </IconLinks>
              <IconLinks>
                <StyledLink
                  to="/rss.xml"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SocialIcon src={Rss} alt="rss" />
                </StyledLink>
              </IconLinks>
            </Footer>
            <GlobalStyles />
          </>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
